import React from 'react';
import { CloseIcon } from './Icons';

interface EmojiPickerModalProps {
    isOpen: boolean;
    onClose: () => void;
    onEmojiSelect: (emoji: string) => void;
}

const EMOJI_CATEGORIES = [
    {
        name: 'Smileys & Emotion',
        emojis: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯', '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '😈', '👿', '👹', '👺', '🤡', '👻', '💀', '☠️', '👽', '👾', '🤖', '🎃', '😺', '😸', '😻', '😼', '😽', '🙀', '😿', '😾']
    },
    {
        name: 'Gestures & Body',
        emojis: ['👋', '🤚', '🖐', '✋', '🖖', '👌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️', '💅', '🤳', '💪', '🦾']
    },
    {
        name: 'Hearts & Symbols',
        emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮️', '✝️', '☪️', '🕉', '☸️', '✡️', '🔯', '🕎', '☯️', '☦️', '🛐', '⛎', '♈️', '♉️', '♊️', '♋️', '♌️', '♍️', '♎️', '♏️', '♐️', '♑️', '♒️', '♓️', '🆔', '⚛️', '🉑', '☢️', '☣️', '📴', '📳', '🈶', '🈚️', '🈸', '🈺', '🈷️', '✴️', '🆚', '💮', '🉐', '㊙️', '㊗️', '🈴', '🈵', '🈹', '🈲', '🅰️', '🅱️', '🆎', '🆑', '🅾️', '🆘', '❌', '⭕️', '🛑', '⛔️', '📛', '🚫', '💯', '💢', '♨️', '🚷', '🚯', '🚳', '🚱', '🔞', '📵', '🚭', '❗️', '❕', '❓', '❔', '‼️', '⁉️', '🔅', '🔆', '〽️', '⚠️', '🚸', '🔱', '⚜️', '🔰', '♻️', '✅', '🈯️', '💹', '❇️', '✳️', '❎', '🌐', '💠', 'Ⓜ️', '🌀', '💤', '🏧', '🚾', '♿️', '🅿️', '🈳', '🈂️', '🛂', '🛃', '🛄', '🛅', '🚹', '🚺', '🚼', '🚻', '🚮', '🎦', '📶', '🈁', '🔣', 'ℹ️', '🔤', '🔡', '🔠', '🆖', '🆗', '🆙', '🆒', '🆕', '🆓', '0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟', '🔢', '▶️', '⏸', '⏯', '⏹', '⏺', '⏏️', '⏭', '⏮', '⏩', '⏪', '⏫', '⏬', '◀️', '🔼', '🔽', '➡️', '⬅️', '⬆️', '⬇️', '↗️', '↘️', '↙️', '↖️', '↕️', '↔️', '↪️', '↩️', '⤴️', '⤵️', '🔀', '🔁', '🔂', '🔄', '🔃', '🎵', '🎶', '➕', '➖', '➗', '✖️', '♾', '💲', '💱', '™️', '©️', '®️', '👁‍🗨', '🔚', '🔙', '🔛', '🔝', '🔜', '〰️', '➰', '➿', '✔️', '☑️', '🔘', '⚪️', '⚫️', '🔴', '🔵', '🟤', '🟣', '🟢', '🟡', '🟠', '🟥', '🟦', '🟫', '⬛️', '⬜️', '🟪', '🟩', '🟨', '🟧', '📁', '📂', '🗂', '📅', '📆', '🗒', '🗓', '📇', '📈', '📉', '📊', '📋', '📌', '📍', '📎', '🖇', '📏', '📐', '✂️', '🗃', '🗄', '🗑']
    },
    {
        name: 'Activity & Objects',
        emojis: ['⚽️', '🏀', '🏈', '⚾️', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱', '🪀', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏', '🥅', '⛳️', '🪁', '🏹', '🎣', '🤿', '🥊', '🥋', '🛹', '🛷', '⛸', '🥌', '🎿', '⛷', '🏂', '🏋️‍♀️', '🏋️‍♂️', '🤼‍♀️', '🤼‍♂️', '🤸‍♀️', '🤸‍♂️', '⛹️‍♀️', '⛹️‍♂️', '🤺', '🤾‍♀️', '🤾‍♂️', '🏌️‍♀️', '🏌️‍♂️', '🏇', '🧘‍♀️', '🧘‍♂️', '🏄‍♀️', '🏄‍♂️', '🏊‍♀️', '🏊‍♂️', '🤽‍♀️', '🤽‍♂️', '🚣‍♀️', '🚣‍♂️', '🧗‍♀️', '🧗‍♂️', '🚵‍♀️', '🚵‍♂️', '🚴‍♀️', '🚴‍♂️', '🏆', '🥇', '🥈', '🥉', '🏅', '🎖', '🏵', '🎗', '🎫', '🎟', '🎪', '🤹‍♀️', '🤹‍♂️', '🎭', '🩰', '🎨', '🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🎷', '🎺', '🎸', '🪕', '🎻', '🎲', '♟', '🎯', '🎳', '🎮', '🎰', '🧩']
    }
];

export const EmojiPickerModal = ({ isOpen, onClose, onEmojiSelect }: EmojiPickerModalProps) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[100]" onClick={onClose}>
            <div
                className="bg-gray-900 w-full max-w-sm mx-4 rounded-2xl shadow-2xl overflow-hidden border border-gray-700 flex flex-col max-h-[70vh]"
                onClick={e => e.stopPropagation()}
                data-emoji-picker="true"
            >
                <div className="p-4 border-b border-gray-800 flex justify-between items-center bg-gray-900/50">
                    <h3 className="text-lg font-bold text-white">Choose Emoji</h3>
                    <button onClick={onClose} className="p-1 hover:bg-white/10 rounded-full transition-colors">
                        <CloseIcon className="w-5 h-5 text-gray-400" />
                    </button>
                </div>

                <div className="flex-grow overflow-y-auto p-4 custom-scrollbar">
                    {(() => {
                        const saved = typeof window !== 'undefined' ? localStorage.getItem('recent_emojis') : null;
                        const recentEmojis: string[] = saved ? JSON.parse(saved) : [];
                        if (recentEmojis.length === 0) return null;
                        return (
                            <div className="mb-6">
                                <h4 className="text-xs font-bold text-blue-400 uppercase tracking-widest mb-3 px-1 flex items-center gap-2">
                                    <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse"></span>
                                    Recently Used
                                </h4>
                                <div className="grid grid-cols-7 gap-2">
                                    {recentEmojis.map(emoji => (
                                        <button
                                            key={`recent-${emoji}`}
                                            onClick={() => {
                                                onEmojiSelect(emoji);
                                                try {
                                                    const saved = localStorage.getItem('recent_emojis');
                                                    const recents: string[] = saved ? JSON.parse(saved) : [];
                                                    const filtered = recents.filter(x => x !== emoji);
                                                    const newRecents = [emoji, ...filtered].slice(0, 14);
                                                    localStorage.setItem('recent_emojis', JSON.stringify(newRecents));
                                                } catch (e) {
                                                    console.error(e);
                                                }
                                            }}
                                            className="text-2xl hover:bg-white/10 p-1.5 rounded-lg transition-all hover:scale-125 flex items-center justify-center"
                                        >
                                            <span className="sticker-outline">{emoji}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        );
                    })()}

                    {EMOJI_CATEGORIES.map(category => (
                        <div key={category.name} className="mb-6">
                            <h4 className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-3 px-1">{category.name}</h4>
                            <div className="grid grid-cols-7 gap-2">
                                {category.emojis.map(emoji => (
                                    <button
                                        key={emoji}
                                        onClick={() => {
                                            onEmojiSelect(emoji);
                                            try {
                                                const saved = localStorage.getItem('recent_emojis');
                                                const recents: string[] = saved ? JSON.parse(saved) : [];
                                                const filtered = recents.filter(x => x !== emoji);
                                                const newRecents = [emoji, ...filtered].slice(0, 14);
                                                localStorage.setItem('recent_emojis', JSON.stringify(newRecents));
                                            } catch (e) {
                                                console.error(e);
                                            }
                                        }}
                                        className="text-2xl hover:bg-white/10 p-1.5 rounded-lg transition-all hover:scale-125 flex items-center justify-center"
                                    >
                                        <span className="sticker-outline">{emoji}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
